import { action } from 'satcheljs';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type { MailboxInfo } from 'owa-client-types';

export interface OnMailServiceNewMessageActionMessage {
    mailboxInfo: MailboxInfo;
    toEmailAddressWrappers: EmailAddressWrapper[] | undefined;
    ccEmailAddressWrappers: EmailAddressWrapper[] | undefined;
    bccEmailAddressWrappers: EmailAddressWrapper[] | undefined;
    subject: string | undefined;
    body: string | undefined;
}
const onMailServiceNewMessage: (
    mailboxInfo: MailboxInfo,
    toEmailAddressWrappers?: EmailAddressWrapper[],
    ccEmailAddressWrappers?: EmailAddressWrapper[],
    bccEmailAddressWrappers?: EmailAddressWrapper[],
    subject?: string,
    body?: string
) => OnMailServiceNewMessageActionMessage = action(
    'onMailServiceNewMessage',
    (
        mailboxInfo: MailboxInfo,
        toEmailAddressWrappers?: EmailAddressWrapper[],
        ccEmailAddressWrappers?: EmailAddressWrapper[],
        bccEmailAddressWrappers?: EmailAddressWrapper[],
        subject?: string,
        body?: string
    ): OnMailServiceNewMessageActionMessage => ({
        mailboxInfo,
        toEmailAddressWrappers,
        ccEmailAddressWrappers,
        bccEmailAddressWrappers,
        subject,
        body,
    })
);

export default onMailServiceNewMessage;
